/** @jsxImportSource @emotion/react */
import { Pages } from 'modules/navigation/domain/enums/pages';
import { theme } from 'styles/theme/theme';
import useCustomModal from 'ud-ui/components/custom-modal/use-custom-modal';
import CrossThinIcon from 'ud-ui/components/icon/cross-thin-icon';
import UDText from 'ud-ui/components/text';
import Button from 'modules/board-master/ui/components/button';
import { WaterMarkCss } from 'modules/board-master/ui/components/styles';
import TMLabel from 'modules/board-master/ui/components/tm-label';
import { OfflineModalCss } from '../styles';
import UrlInput from '../urlInput';

const domain = window.location.origin;
const offlineBoardUrl = domain + Pages.MASTER_BOARDS.builders.controlPanel('');

function useOfflineModal() {
  const { defaultOpen, close, Modal: OfflineModal } = useCustomModal();

  const open = () => {
    defaultOpen(
      {
        containerProps: {
          css: OfflineModalCss,
          style: {
            padding: '42px 60px',
            width: '80%',
            maxWidth: 938,
            height: 479,
            overflow: 'hidden',
            zIndex: 0,
          },
        },
      },
      <CrossThinIcon color={theme.colors.Gray} className="modal-close-icon" />,
    );
  };

  const handleOpenOfflinePanel = () => {
    window.open(offlineBoardUrl, '_blank');
  };

  const Modal = () => (
    <OfflineModal>
      <UDText type={'title-large'} className={'fw-800 header'} color={theme.colors.DarkBlue}>
        Все готово чтобы начать!
      </UDText>
      <UDText className="description" color={theme.colors.Blue} type={'subhead'} style={{ fontSize: 22, marginTop: 37 }}>
        Ссылка для открытия
        <span className={'text fw-700'} style={{ fontSize: 22, marginTop: 37, color: 'inherit' }}>
          {' панели управления табло'}
        </span>
      </UDText>
      <div className={'control mt-3 flex flex-row justify-between gap-6'}>
        <UrlInput className="url-open-panel" value={offlineBoardUrl} />
        <Button className="open-panel-button" onClick={handleOpenOfflinePanel} variant={'dark-yellow'}>
          Открыть
        </Button>
      </div>

      <UDText
        className="tip"
        type={'subhead'}
        style={{ fontSize: 18, marginTop: 34, width: '80%', lineHeight: 'unset', fontWeight: 300 }}
        color={'#8E8E8E'}
      >
        По этой ссылке откроется панель управления табло. Само табло можно будет открыть из панели.
      </UDText>
      <TMLabel className="watermark" fontSize={320} lineHeight={320} css={WaterMarkCss} />
    </OfflineModal>
  );

  return { open, close, Modal };
}

export default useOfflineModal;
